export default "__VITE_ASSET__DPFqw34z__"